module.exports = __webpack_public_path__ + "img/8.cea701f1.jpeg";